export const SET_AUTHENTICATED_USER = 'SET_AUTHENTICATED_USER';
export const AUTHENTICATION_FAILED = 'AUTHENTICATION_FAILED';
export const RESET_ERRORS = 'RESET_ERRORS';
export const LOGOUT_USER = 'LOGOUT_USER';
